import script from "./ContentRenewableEnergyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentRenewableEnergyComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContentRenewableEnergyComponent.vue?vue&type=style&index=0&id=0c571e85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c571e85"]])

export default __exports__